<template>
  <section class="social-login" v-if="!authStore.isLoggedIn">
    <google-login-button />
    <facebook-continue-button />
  </section>
</template>

<script setup lang="ts">
const authStore = useAuthStore(usePinia())
</script>

<style scoped>
.social-login {
  padding: 1.5em 0 0;
  max-width: max-content;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 1em;
  justify-content: center;
  align-items: start;
}

.social-login :deep(.social-login-btn) {
  min-height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
